'use client';

import styled from '@emotion/styled';
import React from 'react';
import { Typography } from '@diritto/common/style/typography';
import { ButtonSize, ButtonType } from 'constants/button';
import { Error } from 'ui-components/common/Error';
import { HomeLinkButton } from 'ui-components/common/HomeLinkButton';

export const ErrorView = ({
  title,
  description,
  children,
}: {
  title?: string;
  description?: string;
  children?: React.ReactNode;
}) => (
  <StyledWrap>
    <Error title={title} description={description}>
      {children || (
        <HomeLinkButton
          size={ButtonSize.Small}
          buttonType={ButtonType.SecondaryNeutral}
          buttonTypography={Typography.XXXSmall}
          label={'홈으로 가기'}
          replace
          fullWidth
        />
      )}
    </Error>
  </StyledWrap>
);

const StyledWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
`;

export default ErrorView;
